import axios from 'axios';

const ACCESS_CODE_STORAGE_KEY = 'gongju_access_code';

function normalizeAccessCode(raw) {
  const s = String(raw || '').trim();
  // Common operator error: copying "<ACCESS_CODE>" with angle brackets.
  if (s.startsWith('<') && s.endsWith('>') && s.length > 2) return s.slice(1, -1).trim();
  return s;
}

const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  try {
    const code = normalizeAccessCode(window.localStorage.getItem(ACCESS_CODE_STORAGE_KEY) || '');
    if (code) {
      if (config.headers && typeof config.headers.set === 'function') {
        config.headers.set('X-Access-Code', code);
      } else {
        config.headers = config.headers || {};
        config.headers['X-Access-Code'] = code;
      }
    }
  } catch (_) {
    // Ignore localStorage failures (private mode, blocked storage, etc.)
  }
  return config;
});

export const uploadVideo = (file, onUploadProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  // Optional JSON options for per-task overrides (targets/output/style).
  // Backend expects a string field named `options`.
  // Example: {"target_languages":["zh-Hans"],"ass_enabled":true,"burn_subtitles":true}
  // Keep it absent when no options are provided.

  return apiClient.post('/tasks/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

export const uploadVideoWithOptions = (file, onUploadProgress, options) => {
  const formData = new FormData();
  formData.append('file', file);
  if (options) formData.append('options', JSON.stringify(options));

  return apiClient.post('/tasks/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

export const uploadSubtitle = (file, onUploadProgress) => {
  const formData = new FormData();
  formData.append('file', file);

  return apiClient.post('/tasks/upload_subtitle', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

export const uploadSubtitleWithOptions = (file, onUploadProgress, options) => {
  const formData = new FormData();
  formData.append('file', file);
  if (options) formData.append('options', JSON.stringify(options));

  return apiClient.post('/tasks/upload_subtitle', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
};

export const processVideoFromUrl = (url) => {
  return apiClient.post('/tasks/url', { url });
};

export const processVideoFromUrlWithOptions = (url, options) => {
  return apiClient.post('/tasks/url', { url, options: options || {} });
};

export const getTaskStatus = (taskId) => {
  return apiClient.get(`/tasks/${taskId}`);
};

export const getAllTasks = () => {
  return apiClient.get('/tasks');
};

export const cancelTask = (taskId) => {
  return apiClient.post(`/tasks/${taskId}/cancel`);
};

export const retryTask = (taskId) => {
  return apiClient.post(`/tasks/${taskId}/retry`);
};

export const deleteTask = (taskId) => {
  return apiClient.delete(`/tasks/${taskId}`);
};

export const getLanguages = () => {
  return apiClient.get('/languages');
};

export const getPromptPresets = () => {
  return apiClient.get('/prompt-presets');
};

export const getAdminStats = () => {
  return apiClient.get('/admin/stats');
};

export const getLimits = () => {
  return apiClient.get('/limits');
};
